import { Lightning, Log, Router } from '@lightningjs/sdk';
import { Base } from '../../components/BaseComponent';
import { modalTSpec, modalTypeConf } from './Modal.conf';

export class Modal extends Base<modalTSpec, modalTypeConf> {
  static override _template() {
    return {
      w: (w: number) => w,
      h: (h: number) => h,
      Container: {
        type: Lightning.Component,
        w: (w: number) => w,
        h: (h: number) => h,
        visible: false,
      },
    };
  }

  private modalBackStack: Lightning.Element[] = [];
  private maxBackStackDepth = 5;
  private container = this.getByRef('Container')!;
  public name = '';

  override _getFocused(): Lightning.Component {
    if (this.modalBackStack.length !== 0) {
      return this.modalBackStack[this.modalBackStack.length - 1] as Lightning.Component;
    } else {
      return this;
    }
  }

  override _active() {
    if (this.modalBackStack.length > 0) {
      Router.focusWidget(this.name);
    }
  }

  $openModal(page: any, params: any) {
    if (params != null) {
      Log.info(`Opening modal ${page.name} with owner`, 'with parameters', params);
    } else {
      Log.info(`Opening modal ${page.name} with owner`);
    }

    const el = this.container.childList.a({
      w: (w: number) => w,
      h: (h: number) => h,
      type: page,
      params: params,
    });
    this.modalBackStack.push(el);
    if (this.modalBackStack.length > this.maxBackStackDepth) {
      const removeEl = this.modalBackStack.shift();
      if (removeEl) {
        this.container.childList.remove(removeEl);
      }
    }

    this.container.visible = true;
    this._refocus();
    Router.focusWidget(this.name);
  }

  $closeModal() {
    Log.info('Closing modal');

    if (this.container.children.length > 0) {
      const modalChild = this.container.childList.removeAt(this.container.children.length - 1);
      this.modalBackStack = this.modalBackStack.filter(el => el !== modalChild);
    }

    this.container.visible = this.container.childList.length > 0;
    this.fireAncestors('$hideMiniDetail');
    if (!this.container.visible) {
      Router.focusPage();
    }
    this._refocus();
  }

  clearModals() {
    this.container.childList.clear();
    this.modalBackStack = [];

    this.container.visible = false;
    this.fireAncestors('$hideMiniDetail');
    Router.focusPage();
    this._refocus();
  }

  // needed to block focus from going across modals
  override _handleKey(): void {}

  public get isVisible() {
    return this.container.visible;
  }
}
